import React, { useState } from 'react';
import {
  dismissWaitstaffInstallHint,
  isStandaloneDisplay,
  isWaitstaffInstallHintDismissed,
  waitstaffInstallHintCopy,
} from '../../lib/waitstaffInstallHint';

const WaitstaffInstallHint: React.FC = () => {
  const [hidden, setHidden] = useState(
    () => isStandaloneDisplay() || isWaitstaffInstallHintDismissed(),
  );
  if (hidden) return null;
  const copy = waitstaffInstallHintCopy();
  return (
    <div className="rounded-2xl border border-pink-200 bg-pink-50 px-4 py-3">
      <p className="text-sm font-bold text-pink-900">{copy.title}</p>
      <p className="text-xs text-pink-800 mt-1 leading-relaxed">{copy.body}</p>
      <button
        type="button"
        onClick={() => {
          dismissWaitstaffInstallHint();
          setHidden(true);
        }}
        className="mt-2 text-xs font-semibold text-pink-700 underline"
      >
        Got it
      </button>
    </div>
  );
};

export default WaitstaffInstallHint;
